import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormView, DialogModal } from ".";
import { showDialog } from "../../appRedux/actions/common";
import { setPlatformsInfo } from "../../appRedux/actions/platforms";
import { useNavigate } from "react-router-dom";

function EditInfo({ info }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));
  console.log({ info, dialog, open });

  useEffect(() => {
    if (!dialog) {
      setOpen(dialog);
    }
  }, [dialog]);

  const onClick = () => {
    setOpen(true);
    dispatch(setPlatformsInfo(info));
    dispatch(showDialog({ title: "Update Platform", size: "lg", id: info._id }));
  };

  return (
    <Fragment>
      <button
        className="dropdown-item"
        onClick={onClick}
        key={"edit_info"}
      >
        <i className="fa fa-pencil m-r-5" /> Edit
      </button>
      {open && (
        <DialogModal
          infoId={info._id}
          key={Math.random()}
          bodyView={<FormView isUpdate={true} reJoin={!info.active} />}
        ></DialogModal>
      )}
    </Fragment>
  );
}

export default EditInfo;
